






















import Vue from 'vue';
import { Person, Attitude } from '@/interfaces/Person';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import DataViewBase from '@/classes/component-bases/DataViewBase';

@Component
export default class CardView extends DataViewBase {
  @Prop()
  private data!: Person[];

  @Prop()
  private attitudeitems!: Attitude[];

  @Prop()
  private search!: string;

  @Prop()
  private singleColumn!: boolean;

  private sorting: string = 'name';

  constructor() {
    super();
  }

  get dataSorted() {

    return this.data.sort((a, b) => {
      if ((typeof a.loadedImageUrl === 'undefined' || !a.loadedImageUrl)
      && (typeof b.loadedImageUrl !== 'undefined' && b.loadedImageUrl !== null)) {
        return 1;
      } else if ((typeof a.loadedImageUrl !== 'undefined' && a.loadedImageUrl !== null)
      && (typeof b.loadedImageUrl === 'undefined' || !b.loadedImageUrl)) {
        return -1;
      }
      return (a[this.sorting] > b[this.sorting]) ? 1 : -1;
    });
  }

  private onCardClick(person: Person) {
    this.$emit('focusperson', person);
  }
}
